import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, User } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { useCart } from "../lib/cart";
import { useState } from "react";

export default function Header({ tiktokHandle, logo }) {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);
  const tiktokUrl = tiktokHandle ? `https://www.tiktok.com/@${tiktokHandle}` : "#";

  const linkCls = ({ isActive }) =>
    `text-[13px] tracking-[0.2em] uppercase font-medium transition-colors duration-200 ${
      isActive ? "text-brand-gold" : "text-brand-bg/85 hover:text-brand-gold"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-brand-ink/95 border-b border-brand-line/20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-2 md:py-3 flex items-center justify-between">
        <div className="flex-1 hidden md:flex items-center gap-8">
          <NavLink to="/shop" className={linkCls} data-testid="nav-shop">Shop</NavLink>
          <NavLink to="/about" className={linkCls} data-testid="nav-about">About</NavLink>
        </div>
        <Link to="/" data-testid="logo-link" className="flex-1 md:flex-none text-center">
          {logo ? (
            <img src={logo} alt="cindymaks Collections" className="h-28 md:h-40 mx-auto object-contain" />
          ) : (
            <>
              <div className="font-serif text-2xl md:text-3xl tracking-tight leading-none text-brand-bg">
                cindymaks
              </div>
              <div className="overline mt-1 text-[10px] text-brand-gold">Collections</div>
            </>
          )}
        </Link>
        <div className="flex-1 flex items-center justify-end gap-5">
          <a
            href={tiktokUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            data-testid="tiktok-social-link"
            className="hidden md:inline-flex text-brand-bg/85 hover:text-brand-gold transition-colors"
          >
            <FaTiktok size={18} />
          </a>
          <Link to="/admin/login" data-testid="admin-link" aria-label="Admin" className="hidden md:inline-flex text-brand-bg/85 hover:text-brand-gold">
            <User size={18} />
          </Link>
          <button
            onClick={() => setOpen(true)}
            data-testid="open-cart-btn"
            aria-label="Open cart"
            className="relative text-brand-bg/85 hover:text-brand-gold transition-colors"
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-2 bg-brand-gold text-brand-ink text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            onClick={() => setMobile(!mobile)}
            className="md:hidden text-brand-bg"
            aria-label="Menu"
            data-testid="mobile-menu-btn"
          >
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t border-brand-line/20 bg-brand-ink" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            <NavLink to="/shop" onClick={() => setMobile(false)} className={linkCls}>Shop</NavLink>
            <NavLink to="/about" onClick={() => setMobile(false)} className={linkCls}>About</NavLink>
            <a href={tiktokUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[13px] tracking-[0.2em] uppercase text-brand-bg">
              <FaTiktok /> TikTok
            </a>
            <Link to="/admin/login" onClick={() => setMobile(false)} className="text-[13px] tracking-[0.2em] uppercase text-brand-bg">Admin</Link>
          </div>
        </div>
      )}
    </header>
  );
}
